import React from "react";
import HeaderTop from "../components/Headertop";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";
import '../components/css/BlogStyle.css';


function TermsCondition(){
    return(
        <>
            <HeaderTop />
            <Navbar />
            <section className="page-banner">
                <div className="container">
                    <div className="banner-content">
                        <h1 className="fw-bold">Privacy Policy</h1>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Privacy Policy</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </section>

            <div class="container my-5">
                <div class="row g-4">
                    <div class="col-lg-12">
                        <h3>Terms Condition</h3>
                        <p></p>
                    </div>
                </div>
            </div>

            <Footer />
        </>
    );
}
export default TermsCondition;